export default "__VITE_ASSET__d5113dac__"